import type { ReactNode } from "react";
import { CloseIcon } from "./icons";

interface Props {
  title: ReactNode;
  width?: string;
  bodyHeight?: string;
  /** Use minHeight instead of fixed height — body grows with content */
  flexibleHeight?: boolean;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Shared modal overlay + card shell used by all deviceInstaller modals.
 * Provides: backdrop, white card, header with title + close button, and a
 * fixed-height body container to prevent layout shifts between states.
 */
const ModalShell = ({
  title,
  width = "34rem",
  bodyHeight = "280px",
  flexibleHeight = false,
  onClose,
  children,
}: Props) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-xl shadow-2xl max-w-[90vw] overflow-hidden" style={{ width }}>
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <h3 className="text-base font-semibold text-gray-800">{title}</h3>
        <button
          onClick={onClose}
          className="w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      <div
        className="px-5 pb-5 flex flex-col"
        style={flexibleHeight ? { minHeight: bodyHeight } : { height: bodyHeight }}
      >
        {children}
      </div>
    </div>
  </div>
);

export default ModalShell;
